module.exports = __webpack_public_path__ + "img/quest_icon_0058_bomb.2f918b77.png";